import React from 'react';
// import axios from 'axios';
// const PORT='http://localhost:3000/users/login';

export default function Login(props){  
  
  return (
    <div>
      <h2>Log In</h2>
      <form>
        <div>
          <label htmlFor="username">Username</label>
          <input type="text" id="username" onChange={props.handleUserForm} />
        </div>
        <div>
          <label htmlFor="password">Password</label>
          <input type="password" id="password" onChange={props.handleUserForm} />
        </div>
        <input value="Submit" className="submit" type="submit" onClick={props.login} />
      </form>
      {(props.isLoggedIn)?
        <button id="logout" onClick={props.logout}>Log Out</button> : '' 
      }
    </div>
  );
}
